import { flagDefinition } from "./feature-flags.js";
/**
 * Reads a boolean feature flag (B2) off a principal, falling back to the
 * flag's registry default when the principal carries no resolved value (a
 * pre-B2 token, an API-key principal, or an org-less session). This is the
 * single read path the app uses — it never queries the flag table.
 */
export function flagEnabled(principal, key) {
    const value = principal.flags?.[key] ?? flagDefinition(key)?.default;
    return value === true;
}
//# sourceMappingURL=types.js.map